export default "__VITE_ASSET__Bdlrxf5L__"